import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
  palette: {
    background: {
      default: '#F5F5F5',
      paper: '#FFF'
    },
    primary: {
      main: '#019592',
      contrastText: '#FFF'
    },
    secondary: {
      main: '#1B2020',
      contrastText: '#FFF'
    },
    text: {
      primary: '#1B2020',
      secondary: '#019592',
      disabled: '#985EFF',
      hint: '#6200EE'
    },
    error: {
      main: '#CF6679',
      contrastText: '#FFF'
    },
    warning: {
      main: '#E7841D',
      contrastText: '#FFF'
    },
    success: {
      main: '#CF6679',
      contrastText: '#FFF'
    }
  },
  typography: {
    h1: {
      fontFamily: 'Roboto-Light',
      fontSize: 96,
      letterSpacing: -1.5,
      color: 'rgba(1, 0, 0, 0.87)',
      lineHeight: '112px'
    },
    h2: {
      fontFamily: 'Roboto-Light',
      fontSize: 60,
      letterSpacing: -0.5,
      color: 'rgba(0, 0, 0, 0.87)',
      lineHeight: '72px'
    },
    h3: {
      fontFamily: 'Roboto-Regular',
      fontSize: 48,
      letterSpacing: 0,
      lineHeight: '56px'
    },
    h4: {
      fontFamily: 'Roboto-Regular',
      fontSize: 34,
      letterSpacing: 0.25,
      color: 'rgba(0, 0, 0, 0.87)'
    },
    h5: {
      fontFamily: 'Roboto-Regular',
      fontSize: 24,
      letterSpacing: 0,
      color: 'rgba(0, 0, 0, 0.87)',
      lineHeight: '24px'
    },
    h6: {
      fontFamily: 'Roboto-Medium',
      fontSize: 20,
      letterSpacing: 0.25,
      color: 'rgba(0, 0, 0, 0.87)'
    },
    body1: {
      fontFamily: 'Roboto-Regular',
      fontSize: 16,
      letterSpacing: 0.5,
      lineHeight: '24px',
      color: 'rgba(0, 0, 0, 0.87)'
    },
    body2: {
      fontFamily: 'Roboto-Regular',
      fontSize: 14,
      letterSpacing: 0.25,
      color: 'rgba(0, 0, 0, 0.87)'
    },
    subtitle1: {
      fontFamily: 'Roboto-Regular',
      fontSize: 16,
      letterSpacing: 0.15,
      color: 'rgba(0, 0, 0, 0.87)',
      lineHeight: '24px',
      textTransform: 'uppercase'
    },
    subtitle2: {
      fontFamily: 'Roboto-Medium',
      fontSize: 14,
      letterSpacing: 0.1
    },
    button: {
      fontFamily: 'Roboto-Medium',
      fontSize: 14,
      letterSpacing: 1.25,
      lineHeight: '16px'
    },
    caption: {
      fontFamily: 'Roboto-Regular',
      fontSize: 12,
      letterSpacing: 0.4,
      color: 'rgba(0, 0, 0, 0.87)',
      lineHeight: '16px'
    },
    overline: {
      fontFamily: 'Roboto-Medium',
      fontSize: 12,
      letterSpacing: 2,
      color: 'rgba(0, 0, 0, 0.87)'
    },

    useNextVariants: true,
    fontSize: 16
  },

  breakpoints: {
    keys: ['xs', 'sm', 'md', 'lg', 'bg', 'xl'],
    values: {
      xs: 0,
      sm: 360,
      md: 760,
      lg: 1024,
      xl: 1440
    }
  },
  overrides: {
    MuiButton: {
      outlined: {
        paddingTop: 10,
        paddingBottom: 10
      },
      contained: {
        paddingTop: 10,
        paddingBottom: 10
      }
    },
    MuiCard: {
      root: {
        '& .card__content--align-center': {
          textAlign: 'center'
        },
        borderRadius: 0,
        backgroundColor: '#FFF'
      }
    },
    MuiCardContent: {
      root: {
        height: '100%'
      }
    },
    MuiList: {
      padding: {
        padding: 0,
        paddingTop: 0,
        paddingBottom: 0
      }
    },
    MuiListItem: {
      root: {
        paddingTop: 0,
        paddingBottom: 0
      },
      button: {}
    },
    MuiListItemText: {
      multiline: {
        marginTop: 12,
        marginBottom: 11,
        marginLeft: 16,
        marginRight: 16
      },
      root: {
        marginTop: 12,
        marginBottom: 12,
        marginLeft: 16,
        marginRight: 16,
        paddingTop: 2,
        paddingBottom: 2
      },
      primary: {
        fontFamily: 'Roboto-Regular',
        fontSize: 16,
        color: '#242B44',
        letterSpacing: 0.5,
        lineHeight: '28px'
      },
      secondary: {
        fontFamily: 'Roboto-Medium',
        fontSize: 14,
        letterSpacing: 0.1,
        color: 'rgba(0, 0, 0, 0.60)',
        lineHeight: '24px'
      }
    },
    MuiSvgIcon: {
      root: {
        fontSize: '1.2rem'
      }
    },
    MuiTabs: {
      root: {
        width: '100%'
      },
      flexContainer: {
        '& a': {
          textDecoration: 'none'
        }
      }
    },
    MuiTab: {
      root: {
        fontFamily: 'Roboto-Regular',
        '&$selected': {
          fontFamily: 'Roboto-Medium'
        }
      },
      labelIcon: {
        '& span > *:first-child': {
          margin: '0 4px 3px 0 !important'
        }
      },
      wrapper: {
        flexDirection: 'row'
      }
    },
    MuiBreadcrumbs: {
      root: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '2.5%'
      },
      li: {
        color: '#CFD5E5',
        fontSize: '11px',
        '& > p': {
          color: '#FFF',
          fontSize: '11px'
        }
      },
      separator: {
        color: '#CFD5E5',
        fontSize: '11px'
      }
    },
    MuiPickersDay: {
      dayDisabled: {
        color: '#c5c5c5'
      }
    },
    MuiPickersCalendarHeader: {
      dayLabel: {
        color: '#019592'
      }
    }
  }
});
